import { render, staticRenderFns } from "./saved-builds.vue?vue&type=template&id=7667c8cc&"
import script from "./saved-builds.vue?vue&type=script&lang=js&"
export * from "./saved-builds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports